package com.karawek.core.ui.designcatalog

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.karawek.core.ui.designcatalog.sections.CatalogColors
import com.karawek.core.ui.designcatalog.sections.CatalogComponents
import com.karawek.core.ui.designcatalog.sections.CatalogEmptyStates
import com.karawek.core.ui.designcatalog.sections.CatalogHaptics
import com.karawek.core.ui.designcatalog.sections.CatalogLists
import com.karawek.core.ui.designcatalog.sections.CatalogMotion
import com.karawek.core.ui.designcatalog.sections.CatalogNavigation
import com.karawek.core.ui.designcatalog.sections.CatalogPreviews
import com.karawek.core.ui.designcatalog.sections.CatalogSpacing
import com.karawek.core.ui.designcatalog.sections.CatalogStructure
import com.karawek.core.ui.designcatalog.sections.CatalogTypography
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun DesignCatalog(
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier
            .padding(CoreSpacing.lg)
            .verticalScroll(rememberScrollState()),
    ) {
        Text(
            text = "Design Catalog",
            style = CoreTypography.headline,
        )
        Spacer(Modifier.height(CoreSpacing.lg))

        CatalogColors()
        Spacer(Modifier.height(CoreSpacing.xl))

        CatalogTypography()
        Spacer(Modifier.height(CoreSpacing.xl))

        CatalogSpacing()
        Spacer(Modifier.height(CoreSpacing.xl))

        CatalogComponents()
        Spacer(Modifier.height(CoreSpacing.xl))

        CatalogPreviews()
        Spacer(Modifier.height(CoreSpacing.xl))

        CatalogStructure()

        Spacer(Modifier.height(CoreSpacing.xl))
        CatalogLists()

        Spacer(Modifier.height(CoreSpacing.xl))
        CatalogEmptyStates()

        Spacer(Modifier.height(CoreSpacing.xl))
        CatalogNavigation()

        Spacer(Modifier.height(CoreSpacing.xl))
        CatalogMotion()

        Spacer(Modifier.height(CoreSpacing.xl))
        CatalogHaptics()
    }
}
